export enum AdminPanelUsersNavigationContextMode {
  UserDetails = 'user-details',
  OrganizationDetails = 'organization-details',
}
